<!-- autoFocus: direct in het naamveld kunnen typen (de soortkeuze-knoppen zijn
     anders het eerste tabbare element); de dialog opent altijd op 'standard'. -->
<e-dialog
  [open]="open()"
  (openChange)="open.set($event)"
  [title]="text().title"
  [closeLabel]="text().close"
  size="md"
  autoFocus="#chart-create-name"
>
  <ng-template>
    <!-- Soortkeuze: standaard geboorte-invoer of composiet uit twee library-charts. -->
    <div class="hd-chart-create-dialog__kinds" role="tablist">
      <button type="button" class="hd-chart-create-dialog__kind"
              [class.is-active]="kind() === 'standard'"
              [attr.aria-selected]="kind() === 'standard'"
              (click)="setKind('standard')">
        {{ text().kindStandard }}
      </button>
      <button type="button" class="hd-chart-create-dialog__kind"
              [class.is-active]="kind() === 'composite'"
              [attr.aria-selected]="kind() === 'composite'"
              (click)="setKind('composite')">
        {{ text().kindComposite }}
      </button>
    </div>

    @if (kind() === 'composite') {
      <hd-composite-create-form [calculateOnlyOffered]="calculateOnlyOffered()" (calculated)="onCalculated($event)" (cancelled)="open.set(false)"></hd-composite-create-form>
    } @else {
      <hd-chart-create-form [calculateOnlyOffered]="calculateOnlyOffered()" (calculated)="onCalculated($event)" (cancelled)="open.set(false)"></hd-chart-create-form>
    }
  </ng-template>
</e-dialog>
